export default "__VITE_ASSET__34606dc0__"